// PanelDoc Component

import React, { Component } from 'react'
import ReatDOM from 'react-dom'
import PropTypes from 'prop-types'
import Dropzone from 'dropzone'
import isObject from 'lodash/isObject'

import Util from '../../../lib/util.jsx'
import ProgressBar from '../../../common/common/progress_bar/progress_bar.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import { ALLOWED_UPLOAD_FILE_TYPES } from '../../../../shared/constants'
import { trackFileUpload } from './utils.js'
import AttachmentFile from './attacthment_file.js'
import { stripFileName } from '../../../../shared/util/file.js'

const allowedUploadFileTypes = Object.values(ALLOWED_UPLOAD_FILE_TYPES).join(
  ','
)

class PanelDoc extends Component {
  constructor (props) {
    super(props)

    this.state = {
      progressValue: 0
    }

    this._references = {
      refUpload: React.createRef()
    }

    this.dropZone = null
  }

  static get propTypes () {
    return {
      className: PropTypes.string,
      onDelete: PropTypes.func,
      uploadSuccess: PropTypes.func,
      error: PropTypes.bool,
      files: PropTypes.array,
      uploadClassName: PropTypes.string,
      baseDownloadUrl: PropTypes.string,
      items: PropTypes.array,
      isViewMode: PropTypes.bool,
      showAttachments: PropTypes.bool,
      uploadUrl: PropTypes.string,
      paramsToIncludeDuringUpload: PropTypes.object // e.g. {userId: '1234'}
    }
  }

  static get defaultProps () {
    return {
      className: 'content',
      onDelete: null,
      uploadSuccess: null,
      error: false,
      files: [],
      uploadClassName: '',
      baseDownloadUrl: null,
      items: [],
      isViewMode: false,
      showAttachments: true,
      uploadUrl: '/api/uploads'
    }
  }

  componentDidMount () {
    this.initUpload()
  }

  initUpload () {
    if (this._references.refUpload.current) {
      this.dropZone = new Dropzone(
        ReatDOM.findDOMNode(this._references.refUpload.current),
        {
          paramName: 'uri',
          maxFilesize: 10,
          url: this.props.uploadUrl,
          uploadMultiple: false,
          previewTemplate: '<div class="dz-preview"></div>',
          hiddenInputContainer: '.content',
          clickable: [`.${this.props.uploadClassName} > .content`],
          acceptedFiles: allowedUploadFileTypes
        }
      )

      this.dropZone.on('error', this._onError.bind(this))
      this.dropZone.on('uploadprogress', this._onProgress.bind(this))
      this.dropZone.on('success', this._onSuccess.bind(this))

      const { paramsToIncludeDuringUpload } = this.props

      if (isObject(paramsToIncludeDuringUpload)) {
        this.dropZone.on('sending', (file, xhr, formData) => {
          Object.entries(paramsToIncludeDuringUpload).map(([key, value]) => formData.append(key, value))
        })
      }
    }
  }

  componentWillUnmount () {
    if (this.dropZone) {
      this.dropZone.disable()
      this.dropZone = null
    }
  }

  render () {
    const {
      items,
      baseDownloadUrl,
      isViewMode,
      uploadClassName,
      error,
      showAttachments
    } = this.props
    const { hasError, progressValue } = this.state

    let uploader = null
    if (progressValue > 0) {
      uploader = (
        <div className='upload-progress'>
          <ProgressBar
            value={progressValue}
            mode='determinate'
            min={0}
            max={100}
            type='circular'
            className='avatar-progress'
          />
        </div>
      )
    }

    const _className = `docupload${error ? ' error' : ''} ${uploadClassName}`

    return (
      <div className='panel panel-doc'>
        {showAttachments && (
          <div className={`doclist${isViewMode && ' viewdoc'}`}>
            {items.map((item, idx) => (
              <AttachmentFile
                key={idx}
                href={`${baseDownloadUrl}/${stripFileName(item.fileName)}`}
                name={item.fileDisplayName}
                onDelete={
                  !isViewMode ? this._onDelete.bind(this, idx) : undefined
                }
              />
            ))}
          </div>
        )}
        {!isViewMode && (
          <div className={_className} ref={this._references.refUpload}>
            <div className='content'>
              <span className='message'>
                <IconButton icon='import' type='transparent' size='huge' />
                <span className='placeholder'>
                  <strong>
                    <IntlMessage ident='plannerv2.task.dragFileHere' />
                  </strong>{' '}
                  <IntlMessage ident='plannerv2.task.OrClickToBrowse' />
                </span>
              </span>
            </div>
            {uploader}
          </div>
        )}
        {hasError && (
          <p className='upload-error'>
            <IntlMessage ident='plannerv2.task.uploadError' />
          </p>
        )}
      </div>
    )
  }

  /* Private functions */
  _onDelete (idx, e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ progressValue: 0 })

    if (this.props.onDelete) {
      this.props.onDelete(idx)
    }
  }

  _onSuccess (file, message, e) {
    const ext = Util.getExtension(message.id)
    if (file) {
      trackFileUpload(file)
    }

    if (ext === 'html') {
      this.setState({
        progressValue: 0
      })
    } else {
      this.setState({ progressValue: 0 })
    }

    this.setState({ hasError: false })

    if (this.props.uploadSuccess) {
      this.props.uploadSuccess(file, message, e)
    }
  }

  _onError (file, message, _e) {
    this.setState({ progressValue: 0, hasError: true })
  }

  _onProgress (file, progress, _e) {
    this.setState({ hasError: false })
    this.setState({ progressValue: progress })
  }
}

export default PanelDoc
